import { EDITABLE, defaultText } from "../../lib/i18n";
import { inputCls } from "./Field";

const TextRow = ({ k, label, lines, long, value, onChange }) => {
  const multi = lines || long;
  const Input = multi ? "textarea" : "input";
  const set = (lang, v) => onChange({ ...value, [lang]: v });
  return (
    <div className="grid gap-3 border-t border-white/[0.06] py-4 first:border-t-0 lg:grid-cols-[200px_1fr_1fr]" data-testid={`admin-text-${k}`}>
      <div>
        <p className="text-sm font-semibold text-white">{label}</p>
        {lines && <p className="mt-0.5 text-xs text-zinc-500">One item per line</p>}
      </div>
      {["en", "ar"].map((lang) => (
        <label key={lang} className="block">
          <span className="mb-1 block font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500">{lang === "en" ? "English" : "Arabic"}</span>
          <Input dir={lang === "ar" ? "rtl" : "ltr"} rows={multi ? (lines ? 3 : 3) : undefined}
            className={`${inputCls} ${lang === "ar" ? "font-arabic" : ""} ${multi ? "resize-y" : ""}`}
            value={value?.[lang] || ""} placeholder={defaultText(lang, k)}
            onChange={(e) => set(lang, e.target.value)} data-testid={`admin-text-${k}-${lang}`} />
        </label>
      ))}
    </div>
  );
};

export const TextsEditor = ({ texts, onChange }) => (
  <div className="space-y-4" data-testid="admin-texts-editor">
    <p className="text-sm text-zinc-400">Leave a box empty to keep the original wording (shown in grey).</p>
    {EDITABLE.map((g) => (
      <section key={g.group} className="rounded-2xl border border-white/10 bg-[#12121A] px-5 py-2">
        <h3 className="py-3 font-display text-lg font-bold text-white">{g.group}</h3>
        {g.items.map(([k, label, lines, long]) => (
          <TextRow key={k} k={k} label={label} lines={lines} long={long} value={texts[k]}
            onChange={(v) => onChange({ ...texts, [k]: v })} />
        ))}
      </section>
    ))}
  </div>
);
